module.exports = __webpack_public_path__ + "static/88-3e936685951b978e5b0e93a8e1e7358d.png";